import axios from "@/api/axiosInstance";
import { FetchMyVouchersParams, FetchMyVouchersResponse } from "./types";

export const fetchMyVouchers = async (
  params: FetchMyVouchersParams = {},
  signal?: AbortSignal,
): Promise<FetchMyVouchersResponse> => {
  const response = await axios.get<FetchMyVouchersResponse>(
    "/api/private/my/vouchers",
    { params, signal },
  );
  return response.data;
};
